import { reactive, readonly } from 'vue';

/**
 * Konfirmasi berbasis janji (promise), dipakai bersama ConfirmDialog.
 *
 * Pemakaian di komponen:
 *
 *   import { useConfirm } from '@/composables/useConfirm';
 *   const { konfirmasi } = useConfirm();
 *
 *   async function hapus(baris) {
 *     const setuju = await konfirmasi({
 *       title: 'Hapus kontingen?',
 *       itemName: baris.name,
 *     });
 *     if (!setuju) return;
 *     ...
 *   }
 *
 * Satu keadaan dipakai bersama seluruh aplikasi sehingga hanya perlu ada
 * SATU <ConfirmDialog> di layout, bukan satu per tabel.
 */

const state = reactive({
  open: false,
  title: 'Konfirmasi',
  message: '',
  itemName: '',
  confirmText: 'Hapus',
  cancelText: 'Batal',
  tone: 'danger',
  busy: false,
});

let resolver = null;

function konfirmasi(opsi = {}) {
  Object.assign(state, {
    title: opsi.title ?? 'Konfirmasi',
    message: opsi.message ?? '',
    itemName: opsi.itemName ?? '',
    confirmText: opsi.confirmText ?? 'Hapus',
    cancelText: opsi.cancelText ?? 'Batal',
    tone: opsi.tone ?? 'danger',
    busy: false,
    open: true,
  });

  return new Promise((resolve) => {
    resolver = resolve;
  });
}

function setuju() {
  state.open = false;
  if (resolver) { resolver(true); resolver = null; }
}

function batal() {
  state.open = false;
  if (resolver) { resolver(false); resolver = null; }
}

/** Menandai dialog sedang memproses, agar tombol terkunci saat permintaan berjalan. */
function sibuk(nilai) {
  state.busy = Boolean(nilai);
}

export function useConfirm() {
  return { state: readonly(state), konfirmasi, setuju, batal, sibuk };
}

export default useConfirm;
